import { useMemo } from 'react';
import { Select, SelectItem, Avatar } from '@ubiquitel/ui';
import './index.scss';

export interface NavigationAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface NavigationSection {
  label: string;
  actions: NavigationAction[];
  /** When provided, renders an Avatar as the trigger instead of the label text. */
  avatar?: {
    name?: string;
    src?: string;
  };
}

interface NavigationBarProps {
  sections: NavigationSection[];
  productName?: string;
}

const NavigationBar = ({ sections, productName = 'Ubiquitel' }: NavigationBarProps) => {
  const actionMap = useMemo(() => {
    const map: Record<string, NavigationAction> = {};
    for (const section of sections) {
      for (const action of section.actions) {
        map[`${section.label}::${action.label}`] = action;
      }
    }
    return map;
  }, [sections]);

  return (
    <header className="component--navigation-bar">
      <div className="component--navigation-bar__brand">
        <img src="/ubiquitel-logo.svg" alt={productName} className="component--navigation-bar__logo" />
      </div>
      {sections.map((section) => {
        const isRightAligned = section.label === 'Account';

        return (
          <div
            key={section.label}
            className={`component--navigation-bar__section ${isRightAligned ? 'component--navigation-bar__section--right' : ''}`}
          >
            <Select
              value=""
              onValueChange={(value) => {
                const action = actionMap[value];
                if (action) action.onClick();
              }}
              variant="ghost"
              placeholder={section.label}
              fixedWidth="auto"
              className="component--navigation-bar__select"
              triggerIcon={
                section.avatar ? (
                  <Avatar
                    name={section.avatar.name}
                    src={section.avatar.src}
                    size="md"
                  />
                ) : undefined
              }
            >
              {section.actions.map((action) => (
                <SelectItem
                  key={action.label}
                  value={`${section.label}::${action.label}`}
                  disabled={action.disabled}
                >
                  {action.label}
                </SelectItem>
              ))}
            </Select>
          </div>
        );
      })}
    </header>
  );
};

export default NavigationBar;
